import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./filterSearch.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { WireI18n } from '~/modules/stores/i18nStore';
import { filtersStore } from '~/modules/stores/searchFiltersStore';
import { searchStore } from '~/modules/stores/searchStore';
import { debounce } from '~/modules/utilities/browser';
const debounceTimeout = 300;
class FilterSearch extends LightningElement {
  constructor(...args) {
    super(...args);
    this.showfilters = void 0;
    this.container = void 0;
    this.labels = void 0;
    this.keyword = void 0;
  }
  typeChanged() {
    filtersStore.reset();
  }
  searchFilter(keyword) {
    if (keyword && keyword !== '') {
      filtersStore.searchOptions(keyword);
    } else {
      filtersStore.reset();
    }
  }
  handleTextInput(event) {
    this.searchFilter(event.target.value?.trim());
    this.debounceTimer = debounce(this, this.dispatchFilterChangeEvent, [event.target.value?.trim()], this.debounceTimer, debounceTimeout);
  }
  dispatchFilterChangeEvent(filterKeyword) {
    this.dispatchEvent(new CustomEvent('analytics', {
      detail: {
        value: filterKeyword,
        eventType: 'filterKeywordChange',
        elementType: 'filterInput'
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  handleClearSearch() {
    filtersStore.reset();
  }
  get containerClass() {
    return this.container === 'explore' ? 'explore-container' : 'search-container';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(FilterSearch, {
  publicProps: {
    showfilters: {
      config: 0
    },
    container: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.search.filterSearch
        };
      }
    },
    typeChanged: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: searchStore,
          selector: state => state.searchParams.type
        };
      }
    },
    keyword: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: filtersStore,
          selector: state => state.filterKeyword || ''
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(FilterSearch, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;